module.exports = __webpack_public_path__ + "cuttingLineSlide.jpg?d532a9c5fa7e507e1a12698329a034b0";